import { useState, useEffect } from 'react';
import { CheckIcon, CloseIcon, ChevronDownIcon } from './Icons.jsx';
import TagPickQuestion from './TagPickQuestion.jsx';
import './ClassifyQuestion.css';

const DEFAULT_OPTIONS = ['int', 'float'];

export default function ClassifyQuestion(props) {
  // The tag-pick variant asks the same thing (one choice per item) but shows
  // every item as a name tag to strike out, so it has its own screen.
  if (props.question.payload?.variant === 'tags') return <TagPickQuestion {...props} />;
  return <ClassifyList {...props} />;
}

function ClassifyList({ question, answered, onSubmit, look }) {
  // Theme A shows each choice as a big button (int blue, float orange), the
  // way a Kahoot answer is a tap, not a dropdown.
  const buttons = look === 'tag';
  const { payload, revealed } = question;
  const options = payload.choices || DEFAULT_OPTIONS;
  const isLocked = answered || Boolean(revealed);
  const [choices, setChoices] = useState({});

  useEffect(() => {
    setChoices({});
  }, [question.id]);

  const setChoice = (itemId, value) => {
    if (isLocked) return;
    setChoices((prev) => ({ ...prev, [itemId]: value }));
  };

  const allPicked = payload.items.every((item) => choices[item.id]);

  const submit = () => {
    if (isLocked || !allPicked) return;
    onSubmit({ answers: choices });
  };

  return (
    <div className="card stack">
      <div className="row-between">
        <span className="q-kicker">เลือกชนิดข้อมูล</span>
      </div>
      <h2>{payload.instruction}</h2>

      <div className="classify-list">
        {payload.items.map((item) => {
          const picked = choices[item.id];
          const isRight = revealed && picked === item.answer;
          const isWrong = revealed && picked && picked !== item.answer;
          return (
            <div key={item.id} className={`classify-row ${isRight ? 'is-correct' : ''} ${isWrong ? 'is-wrong' : ''}`}>
              <span className="classify-caption">{item.caption}</span>
              {buttons ? (
                <span className="classify-buttons" role="group" aria-label={item.caption}>
                  {options.map((c) => (
                    <button
                      key={c}
                      type="button"
                      className={`classify-btn is-${c} ${picked === c ? 'is-picked' : ''} ${revealed && item.answer === c ? 'is-key' : ''}`}
                      aria-pressed={picked === c}
                      disabled={isLocked}
                      onClick={() => setChoice(item.id, c)}
                    >
                      {c}
                    </button>
                  ))}
                </span>
              ) : (
              <span className="classify-select-wrap">
                <select
                  className="classify-select"
                  value={picked || ''}
                  disabled={isLocked}
                  onChange={(e) => setChoice(item.id, e.target.value)}
                >
                  <option value="" disabled>เลือก...</option>
                  {options.map((c) => (
                    <option key={c} value={c}>{c}</option>
                  ))}
                </select>
                <ChevronDownIcon className="classify-select-chevron" size={14} />
              </span>
              )}
              {revealed && (
                <span className="classify-mark" aria-hidden="true">
                  {isRight && <CheckIcon size={16} />}
                  {isWrong && <CloseIcon size={16} />}
                </span>
              )}
            </div>
          );
        })}
      </div>

      {!isLocked && (
        <button className="btn btn-primary btn-block" disabled={!allPicked} onClick={submit}>
          ยืนยันคำตอบ
        </button>
      )}

      {isLocked && !revealed && (
        <p className="text-dim text-center">
          {answered ? 'ส่งคำตอบแล้ว รอครูเฉลย...' : 'เฉลยคำตอบแล้ว — ปิดรับคำตอบข้อนี้'}
        </p>
      )}

      {revealed && payload.revealNote && (
        <p className="classify-success text-center row" style={{ justifyContent: 'center', gap: '6px' }}>
          <CheckIcon size={16} />
          <span>{payload.revealNote}</span>
        </p>
      )}
    </div>
  );
}
